module.exports = __webpack_public_path__ + "assets/img/avatar.99906c0f.png";